import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-alert-configuraion',
    templateUrl: './alert-configuraion.component.html',
    styleUrls: ['./alert-configuraion.component.scss'],
    standalone: false
})
export class AlertConfiguraionComponent implements OnInit {

  navLinks: any[];
  activeLinkIndex = -1;
activeTab: 'intake' | 'scheduler' = 'intake';
  isSidenavOpen=false;
  selectedProductDetails:any=null;
  constructor(private router: Router) {
    this.navLinks = [
      {
        label: 'Alert Library',
        link: './jsip-alertscreen',
        index: 0
      },
      {
        label: 'Alert Product Mapping',
        link: './jsip-alertproductmapping',
        index: 1
      }
      
    ];
   }

  ngOnInit(): void {
      this.router.events.subscribe((res) => {
      this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.link === '.' + this.router.url));
    });
  }

}
